import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { FAQSection } from '../components/sections/FAQSection';
import { PricingSection } from '../components/sections/PricingSection';
import { Footer } from '../components/sections/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen w-full bg-cement selection:bg-amber selection:text-charcoal" data-id="element-140">
      <HeroSection data-id="element-141" />
      <ProblemSection data-id="element-142" />
      <MechanismSection data-id="element-143" />
      <AudienceSection data-id="element-144" />
      <HowItWorksSection data-id="element-145" />
      <FAQSection data-id="element-146" />
      <PricingSection data-id="element-147" />
      <Footer data-id="element-148" />
    </main>;
}